import { useSelector } from "react-redux";

export const useActiveLanguages = () => {
  const { languages, error } = useSelector(state => state.activeLocales);
  const locales = languages.map(language => language?.code);

  return { languages, error, locales };
};
